import Ornament, { OrnamentVariant } from "./Ornament";
import { C } from "./brandTokens";

interface SectionDividerProps {
  variant?: OrnamentVariant;
  background?: string;
  color?: string;
  className?: string;
}

/**
 * A quiet pause between sections — single centered ornament on the page's
 * cream ground. Used sparingly (narrative beats, not every section).
 * Consistent vertical rhythm keeps the page's meter.
 */
export default function SectionDivider({
  variant = "hairline",
  background = C.cream,
  color = C.txt3,
  className,
}: SectionDividerProps) {
  return (
    <div
      className={`flex items-center justify-center ${className ?? ""}`}
      style={{
        background,
        paddingTop: 64,
        paddingBottom: 64,
      }}
      role="presentation"
      aria-hidden="true"
    >
      <Ornament variant={variant} color={color} width={64} />
    </div>
  );
}
